import { NgClass, SlicePipe, UpperCasePipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { GuardsCheckEnd, Router, RouterModule } from '@angular/router';
import { UserService } from '@app/services/user/user.service';
import { UserStore } from '@app/store/user.store';
import { MENU } from '../../app.routes';

@Component({
  selector: 'app-header-admin',
  standalone: true,
  imports: [
    NgClass,
    MatMenu,
    RouterModule,
    MatButtonModule,
    MatMenuModule,
    UpperCasePipe,
    SlicePipe,
  ],
  templateUrl: './header-admin.component.html',
  styleUrl: './header-admin.component.scss',
})
export class HeaderAdminComponent implements OnInit {
  protected displayBurgerMenu = false;
  protected page!: MENU;
  protected readonly MENU = MENU;
  userStore = inject(UserStore);

  constructor(private router: Router, public userService: UserService) {}

  ngOnInit() {
    const url = this.router.url.split('/').pop();
    // @ts-ignore
    this.page = MENU[url?.toUpperCase()];
    this.router.events.subscribe((event) => {
      // @ts-ignore
      if (event instanceof GuardsCheckEnd) {
        const page = event.urlAfterRedirects.split('/').pop();
        // @ts-ignore
        this.page = page ? MENU[page.toUpperCase()] : undefined;
        return this.page;
      } else {
        return null;
      }
    });
  }

  logout() {
    this.userService.logout();
  }
}
